let pixelInitialized = false;

export const initMetaPixel = () => {
  if (typeof window === "undefined") return;
  if (pixelInitialized) return;

  const pixelId = process.env.REACT_APP_META_PIXEL_ID;

  if (!pixelId) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.warn("Meta Pixel ID (REACT_APP_META_PIXEL_ID) is not set");
    }
    return;
  }

  // Ensure fbq is available – the base loader is injected in public/index.html,
  // but we defensively load it here if it isn't ready yet.
  if (typeof window.fbq !== "function") {
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
  }

  try {
    window.fbq("init", pixelId);
    window.fbq("track", "PageView");
    pixelInitialized = true;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.error("Failed to initialize Meta Pixel", error);
    }
  }
};

export const trackMetaEvent = (eventName, params = {}, eventId) => {

  if (typeof window === "undefined") return;
  if (typeof window.fbq !== "function") return;

  const options = eventId ? { eventID: eventId } : undefined;

  try {
    if (options) {
      window.fbq("track", eventName, params, options);
    } else {
      window.fbq("track", eventName, params);
    }
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.error("Failed to track Meta event", eventName, error);
    }
  }
};

